<template>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
        <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div v-else>
        <transition appear name="slide-fade">
            <div class="row">
                <div class="col-lg-12">
                    <button_back></button_back>
                </div>
                <div class="col-12">
                    <h3 class="text-orange mt-3">{{ title }}</h3>
                </div>
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table table-bordered table-condensed table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th>
                                            Nombre Solicitantes
                                        </th>
                                        <th class="text-center">
                                            Cupos
                                        </th>
                                        <th class="text-center">
                                            Estado Solicitud
                                        </th>
                                        <th class="text-center">
                                            Opciones
                                        </th>
                                    </tr>
                                </thead>
                                <tbody v-for="(solicitud, index_solicitud) in solicitudes" v-bind:key="index_solicitud">
                                    <tr v-if="solicitud.tipo_usuario == 1">
                                        <td class="text-center">{{ index_solicitud + 1 }}</td>
                                        <td>{{ solicitud.nombres + ' ' + solicitud.apellidos }}</td>
                                        <td class="text-center">{{ solicitud.cupo }}</td>
                                        <td class="text-center">
                                            <span>
                                                <span v-if="solicitud.estado == 0"
                                                    class="badge bg-danger fw-bold">Pendiente</span>
                                                <span v-if="solicitud.estado == 1"
                                                    class="badge bg-success fw-bold">Completa</span>
                                            </span>
                                        </td>
                                        <td class="text-center">
                                            <button class="btn btn-outline-primary btn-sm rounded-pill"
                                                @click="actualizar_estado(solicitud.id_solicitud, index_solicitud)">
                                                Cambiar estado
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
import { defineAsyncComponent } from 'vue';
export default {
    name: 'Solicitudes_usuarios_plataforma',
    components: {
        button_back: defineAsyncComponent(() => import('../../../components/BackBtn')),
    },
    data() {
        return {
            loading: true,
            title: null,
            solicitudes: [],
        };
    },
    props: {
        session: Object,
    },
    created: function () {
        this.getTitle();
        this.get_solicitudes();
    },
    methods: {
        getTitle() {
            this.title = 'Solicitudes usuarios plataforma'
            this.loading = false
        },
        get_solicitudes() {
            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                },
            };
            axios
                .get(this.$base_url + "admin/solicitudes_plataforma", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    console.log(response.data.usuarios)
                    this.solicitudes = response.data.usuarios;
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        },
        actualizar_estado($id, $index) {
            let $nuevo_estado = 0
            if (this.solicitudes[$index].estado == 0) {
                $nuevo_estado = 1
            } else {
                $nuevo_estado = 0
            }

            const headers = {
                "Content-Type": "application/json",
                "x-api-key": this.$api_key,
                token: this.session.token,
            };
            let config = {
                headers: headers,
                params: {
                    'id': $id,
                    'estado_solicitud': $nuevo_estado
                },
            };
            axios
                .post(this.$base_url + "admin/actualizar_solicitudes_plataforma", config, {
                    headers: headers,
                })
                .then((response) => {
                    if (!response.data.status) {
                        this.$notify({
                            type: "error",
                            group: "foo",
                            title: "Ups!",
                            text: response.data.message,
                        });
                    }
                    this.get_solicitudes();
                })
                .catch((error) =>
                    this.$notify({
                        type: "error",
                        group: "foo",
                        title: "Ups!",
                        text: error,
                    })
                )
                .finally();
        }
    }
}
</script>
<style scoped></style>